import { Form, Input } from "antd";
import Modal from "../../../../components/generic/Modal";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEditColumn } from "../../../../store/tasks/thunks";
import { selectSelectedTenantId } from "../../../../store/user/selectors";
const AddEditColumn = ({ onCancel, selectedColumn }) => {
  const [form] = Form.useForm();
  const tenant_id = useSelector(selectSelectedTenantId);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();

  const isEdit = useMemo(() => !!selectedColumn?.id, [selectedColumn]);

  useEffect(() => {
    if (selectedColumn?.id) form.setFieldValue("name", selectedColumn?.name);
  }, [selectedColumn]);

  const handleFinish = useCallback(
    async (values) => {
      try {
        setIsSubmitting(true);

        await dispatch(
          addEditColumn({
            ...values,
            tenant_id,
            id: selectedColumn?.id || undefined,
          }),
        ).unwrap();

        onCancel();
      } catch (error) {
        console.log("🚀 ~ AddEditColumn.jsx:12 ~ handleFinish ~ error:", error);
      } finally {
        setIsSubmitting(false);
      }
    },
    [tenant_id, selectedColumn],
  );

  return (
    <Modal
      title={isEdit ? "Edit Column" : "Add Column"}
      open
      onCancel={onCancel}
      onOk={() => form.submit()}
      width={400}
      isProcessing={isSubmitting}
      okText="Save"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        disabled={isSubmitting}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter column name",
            },
          ]}
        >
          <Input placeholder="Enter column name" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddEditColumn;
